import type { YammerCache, YammerCacheConfig } from './types';

let cache: YammerCache;
let cacheConfig: YammerCacheConfig = { ttlInSeconds: 5 };

type GetCache = () => typeof cache | undefined;
export const getCache: GetCache = () => cache;

type SetCache = (newCache: typeof cache, newCacheConfig?: typeof cacheConfig) => void;
export const setCache: SetCache = (newCache, newCacheConfig) => {
  cache = newCache;

  if (newCacheConfig) {
    cacheConfig = newCacheConfig;
  }
};

export type GetCacheConfig = () => typeof cacheConfig;
export const getCacheConfig: GetCacheConfig = () => cacheConfig;
